module.exports = __webpack_public_path__ + "img/home-delivery@2x.ee06afd5.jpg";